var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPayment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.07 3.7C4.76 3.7 3.7 4.76 3.7 6.07v11.46c0 1.31 1.06 2.37 2.37 2.37h11.46c1.31 0 2.37-1.06 2.37-2.37v-1.36a.85.85 0 0 1 1.7 0v1.36c0 2.25-1.82 4.07-4.07 4.07H6.07C3.82 21.6 2 19.78 2 17.53V6.07C2 3.82 3.82 2 6.07 2h11.46c2.25 0 4.07 1.82 4.07 4.07v1.36a.85.85 0 0 1-1.7 0V6.07c0-1.31-1.06-2.37-2.37-2.37zm8.789 4.829a.85.85 0 0 1 1.202 0l2.67 2.67a.85.85 0 0 1 0 1.202l-2.67 2.67a.85.85 0 0 1-1.202-1.202l1.219-1.219H9.46a.85.85 0 0 1 0-1.7h6.618l-1.219-1.219a.85.85 0 0 1 0-1.202",
  clipRule: "evenodd"
})));
export default SvgPayment;